module.exports = __webpack_public_path__ + "index-banner-new.png?75b64498e38e17098adc08e63b2d4c98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-banner-new.png
// module id = 90
// module chunks = 0